import {_urlWorks, request} from "../api";
import {PROJECT_CONST} from "../constants";


export const GetWorks = () => {
    const requestData = {
        url: `${_urlWorks}`,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type: PROJECT_CONST.GET_PROJECT,
                    payload: data
                })
                return data
            })
    };
};


export const GetWorkByIdOrSlug = (id) => {
    const requestData = {
        url: `${_urlWorks}/${id}`,
        method: "GET",
        languageFlag: true,
        token: true
    };
    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                dispatch({
                    type:PROJECT_CONST.GET_PROJECT_BY_ID,
                    payload: data
                })
                return data
            })
    };
};

